<template>
    <main data-scroll-container
        class="bg-[url('/img/index/bg.webp')] bg-cover bg-top-center bg-no-repeat bg-blend-overlay overflow-hidden">
        <FedHeader />
        <section class="relative" data-scroll-section>

            <!-- 光環 -->
            <div data-scroll data-scroll-speed="0.3" class="absolute top-0 left-0 w-full  mix-blend-color-dodge z-1">
                <NuxtImg src="/img/index/halo.webp" alt="" class="w-full h-full object-cover" />
            </div>
            <!-- 果園 -->
            <div data-scroll data-scroll-speed="0.5" class="absolute top-0 left-0 w-full mix-blend-overlay z-2">
                <NuxtImg src="/img/index/orchard.webp" alt="" class="w-full h-full object-cover" />
            </div>
            <!-- 右上光班 -->
            <div data-scroll data-scroll-speed="0.4" class="absolute top-0 right-0  z-2 mix-blend-overlay">
                <NuxtImg src="/img/index/light-spot.webp" alt="" class="w-full h-full object-cover" />

            </div>
            <!-- 上漸層 -->
            <div
                class="absolute top-0 left-0 w-full bg-[linear-gradient(to_bottom,_rgba(52,112,162,0.5)_7%,_rgba(255,255,255,0)_33%,_rgba(255,255,255,0)_50%,_rgba(51,102,153,0.5)_73%)] mix-blend-multiply z-3 h-[200%] pointer-events-none" />
            <div class="relative z-4">
                <!-- 火龍果 -->
                <div ref="pitayaRef"
                    class="relative w-[60%] ml-auto mr-0 lg:mr-[6%] pt-[15%] sm:pt-[10%] md:pt-[7.5%] lg:pt-0 fade-in-right">
                    <NuxtImg src="/img/index/pitaya.webp" alt="" class="w-full h-full object-cover" />
                </div>
                <!-- 箭頭 -->
                <div ref="arrowsRef"
                    class="absolute top-[26%] right-[12%] w-[47.4%] mix-blend-color-dodge fade-in-right">
                    <NuxtImg src="/img/index/arrows.webp" alt="" class="w-full h-full object-cover" />
                </div>

            </div>
            <div class="absolute top-0 left-0 w-full h-full z-5 opacity-40 pointer-events-none">
                <img src="/img/index/grid.webp" alt="" class="w-full h-full object-cover">
            </div>
            <!-- 標題 -->
            <h1 ref="titleRef"
                class="absolute top-[1%] sm:top-[2.5%] md:top-[4%] lg:top-[4%] xl:top-[5%] 3xl:top-[6%] left-[10%] ">
                <!-- 左邊黑點 -->
                <div
                    class="absolute top-[-11%] sm:top-[-15%] md:top-[-25%] lg:top-[-10%] left-0 md:left-[-1%] lg:left-0 w-[15%] lg:w-[29%] z-1 mix-blend-screen fade-in-left">
                    <img src="/img/index/black-dot.webp" alt="" class="w-full h-full object-cover">
                </div>
                <!-- 右邊黑點 -->
                <div
                    class="absolute top-[-15%] sm:top-[-20%] md:top-[-32%] lg:top-[-5%] left-[26%] md:left-[23%] lg:left-[26%] xl:left-[34%] 2xl:left-[44%] 3xl:left-[61%] w-[18.5%] z-1 mix-blend-screen rotate-10 fade-in-left">
                    <img src="/img/index/black-dot.webp" alt="" class="w-full h-full object-cover">
                </div>
                <!-- 右邊下黑點 -->
                <div
                    class="absolute top-[35%] sm:top-[30%] md:top-[24%] lg:top-[6%] xl:top-[8%] 2xl:top-[15%] 3xl:top-[23%] left-[11%] lg:left-[25%] xl:left-[30%] 2xl:left-[45%] 3xl:left-[63%] w-[29%] z-1 mix-blend-screen rotate-10 fade-in-left">
                    <img src="/img/index/black-dot.webp" alt="" class="w-full h-full object-cover">
                </div>
                <div class="relative w-full flex flex-col gap-[10px]">
                    <div class="w-[50%] md:w-[45%] lg:w-[50%] xl:w-[60%] 2xl:w-[75%]  3xl:w-full  relative z-4 pt-5 fade-in-left">
                        <img src="/img/index/title-ai.webp" alt="黃能富教授：從智慧農業到打造新世代AI人才"
                            class="w-full h-full object-cover">
                    </div>

                    <div
                        class=" absolute lg:relative z-4 w-[6.5%] md:w-[8.5%] lg:w-[12.5%]  rotate-270 lg:rotate-0 top-[95%] md:top-[75%] left-[14.5%] md:left-[20.5%] lg:left-0 fade-in-left">
                        <img src="/img/index/title-sub.webp" alt="" class="w-full h-full object-cover">
                    </div>
                    <div
                        class="absolute z-4 w-[25%] xl:w-[30%] 2xl:w-[45%] 3xl:w-[67%] top-[100%] lg:top-[20%] 2xl:top-[25%] 3xl:top-[30%] left-0 lg:left-[14.5%] 3xl:left-[12.5%] fade-in-left">
                        <img src="/img/index/title-practice.webp" alt="" class="w-full h-full object-contain">
                    </div>

                </div>

            </h1>
            <!-- 日期 -->
            <h2 ref="dateRef"
                class="relative flex flex-col  top-[-75px] sm:top-[-125px]  lg:absolute lg:top-[25%] xl:top-[27.5%]   left-[10%] lg:left-[17.5%] xl:left-[14%]  w-[40%] sm:w-[35%] md:w-[30%] lg:w-[25%] 3xl:w-[19%] z-4 fade-in-left">
                <div class="relative w-full z-1">
                    <NuxtImg src="/img/index/date.webp" alt="" class="w-full h-full object-cover" />
                </div>
                <div class="relative w-full lg:w-[80%] z-1 mt-[-10px] 3xl:mt-[-20px]">
                    <NuxtImg src="/img/index/date-text.webp" alt="" class="w-full h-full object-cover" />
                </div>
            </h2>

            <!-- 圖示上 -->
            <div data-scroll data-scroll-speed="0.6"
                class="absolute top-[1%] left-[0%] w-[15%]   z-1 mix-blend-luminosity">
                <NuxtImg src="/img/index/02.webp" alt="" class="w-full h-full object-cover" />
            </div>
            <!-- 圖示下 -->
            <div data-scroll data-scroll-speed="0.7"
                class="absolute top-[13%] sm:top-[23%] md:top-[26%] lg:top-[31%] 2xl:top-[37%] right-[-5%] w-[20%]   z-1 mix-blend-luminosity">
                <NuxtImg src="/img/index/01.webp" alt="" class="w-full h-full object-cover" />
            </div>
            <!-- 內容 -->
            <section class=" relative  flex flex-col items-center pt-[5%] lg:pt-[7.5%] 2xl:pt-[0%]  mt-[-15%] lg:mt-0">

                <div
                    class="absolute top-0 left-0 w-full h-full bg-[linear-gradient(to_bottom,_rgba(2,16,83,0.5)_0%,_rgba(2,16,83,1)_24%,_rgba(2,16,83,1)_100%)] md:bg-[linear-gradient(to_bottom,_rgba(2,16,83,0)_0%,_rgba(2,16,83,1)_24%,_rgba(2,16,83,1)_100%)] z-4 mix-blend-normal pointer-events-none" />
                <div class="w-full flex flex-col items-center px-[5%] relative">

                    <!-- 左上箭頭 -->
                    <div data-scroll data-scroll-speed="0.8"
                        class="absolute top-[9.5%] left-[0%] lg:left-[5%] 2xl:left-[15%] w-[10%] lg:w-[6.2%]  mix-blend-color-dodge z-4  fade-in-right">
                        <NuxtImg src="/img/index/left-arrow.webp" alt="" class="w-full h-full object-cover" />
                    </div>
                    <!-- 右邊箭頭 -->
                    <div data-scroll data-scroll-speed="0.9" ref="textLtRef"
                        class="absolute top-[31%] sm:top-[30%] lg:top-[36%] right-[0%] xl:right-[5%] 2xl:right-[10%] 3xl:right-[21%] w-[8%] lg:w-[4%]  mix-blend-color-dodge z-4 fade-in-left">
                        <NuxtImg src="/img/index/right-arrow.webp" alt="" class="w-full h-full object-cover" />
                    </div>
                    <!-- 光斑 -->
                    <div data-scroll data-scroll-speed="0.2"
                        class="absolute top-[0%] right-[20%] w-[30%]  opacity-50  z-4 mix-blend-overlay">
                        <NuxtImg src="/img/index/light-spot-b.webp" alt="" class="w-full h-full object-cover" />
                    </div>
                    <!-- 內容 -->
                    <div class="relative max-w-[913px] w-full z-4 mb-[2.5%]">
                        <!-- 左上角裝飾圖形 -->
                        <div  class="absolute top-0 left-0 z-1 ">
                            <NuxtImg src="/img/index/text-lt.svg" alt="" class="w-full h-full object-cover" />
                        </div>
                        <!-- 文字內容 -->
                        <div
                            class="text-white text-justify text-[18px] font-normal leading-[1.44] max-w-[854px] mx-auto px-[clamp(24px,5vw,32px)] py-[clamp(32px,5vw,64px)]">
                            <p> 面對高齡化、缺工與氣候變遷等挑戰，農民長期承受巨大壓力。清大電機資訊學院資工系黃能富教授積極投入「科技農場」、「智慧農業」研發，利用無人機、影像分析、大數據與AIoT技術，帶領學生走入田間，開發農作物數位分身、AI視覺辨識系統
                                (AR智慧眼鏡)、AI聽覺辨識系統 (AI智慧敲擊棒) 等應用，協助農民改善質量、預測採收、精準分級，傳承老農經驗，吸引年輕人務農(科技農夫)。<br><br>

                                黃教授三度獲清大傑出教學獎，兩度獲清大傑出產學合作獎，並創辦清大磨課師平台，開授多門磨課師課程，修課總人數超過十萬人。其中計算機網路概論課程連續兩年入選全球五十大最受歡迎公開課。他推動AI走出實驗室，真正落地來解決現場問題，並打造「AI
                                Maker」-實作型 AI 人才培育平台與分散式算力共享聯盟，讓學生可以輕鬆 (no-code) 創造、驗證AI視覺辨識模型與AI聽覺辨識模型等等。<br><br>
                                本次展覽將帶領大家認識人工智慧、物聯網技術和大數據分析在農業領域的實際應用，以及黃教授在人工智慧物聯網上的教學成就與創新精神。
                            </p>
                        </div>

                        <!-- 底部裝飾線 -->
                        <div class="absolute w-[95%] bottom-[12px] lg:bottom-[24px] left-[33px] z-1">
                            <NuxtImg src="/img/index/text-line.svg" alt="" class="w-full h-full object-cover" />
                        </div>

                        <!-- 底部點點裝飾 -->
                        <div
                            class="absolute bottom-[0%] lg:bottom-[24px] left-[42%] lg:left-[344px] z-1 flex items-end lg:items-center gap-1">
                            <!-- 26 個小點 -->
                            <div class=" gap-1 hidden lg:flex">
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                                <div class="w-[5px] h-[16px] bg-[#29CDF2]" />
                            </div>
                            <!-- 長條 -->
                            <div class="w-[clamp(165px,17.5vw,320px)] h-[clamp(8px,2vw,16px)] bg-[#29CDF2]" />
                        </div>
                    </div>

                    <!-- 101010 右 -->
                    <div ref="binary1Ref" data-scroll data-scroll-speed="1.2"
                        class="hidden lg:block absolute right-[0%] lg:right-[11.5%] top-[40.5%] w-[11.5%]   z-4 mix-blend-screen fade-in-right">
                        <NuxtImg src="/img/index/101010.webp" alt="" class="w-full h-full object-cover" />
                    </div>
                    <!-- 101010 左 -->
                    <div ref="binary2Ref" data-scroll data-scroll-speed="1.1"
                        class="hidden lg:block absolute left-[10%] 2xl:left-[18%] top-[40%] w-[11%]   z-4 mix-blend-screen fade-in-left">
                        <NuxtImg src="/img/index/101010x2.webp" alt="" class="w-full h-full object-cover" />
                    </div>
                    <!-- 白塊 -->
                    <div ref="whiteBlockRef" data-scroll data-scroll-speed="0.5"
                        class="hidden lg:block absolute lg:left-[2%] 2xl:left-[15%] top-[45.5%] w-[7%]   z-4 fade-in-up">
                        <NuxtImg src="/img/index/white-block.webp" alt="" class="w-full h-full object-cover" />
                    </div>
                    <!-- 左下箭頭 -->
                    <div ref="bottomArrowRef" data-scroll data-scroll-speed="0.6"
                        class="absolute top-[47.5%] left-[0%] xl:left-[5%] 2xl:left-[19%] w-[4%]  mix-blend-color-dodge z-4 fade-in-up">
                        <NuxtImg src="/img/index/right-arrow.webp" alt="" class="w-full h-full object-cover" />
                    </div>

                    <div class="relative z-5 w-full max-w-[856px] mx-auto pt-[1.5%] mb-[10%] lg:mb-[7.5%] ">


                        <div class="absolute top-[0%] left-[0%] z-4 w-full mix-blend-plus-lighter pointer-events-none">
                            <NuxtImg src="/img/index/pic-conter.webp" alt="" class="w-full h-full object-cover" />
                        </div>


                        <Swiper :modules="[Autoplay]" :autoplay="{ delay: 3000, disableOnInteraction: false }"
                            :loop="true" :slides-per-view="1" :space-between="0" class="relative max-w-[815px] mx-auto"
                            @swiper="onSwiper" @slide-change="onSlideChange">
                            <SwiperSlide>
                                <svg width="100%" height="100%" viewBox="0 0 816 513"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <defs>
                                        <clipPath id="cut1" clipPathUnits="userSpaceOnUse">
                                            <path
                                                d="M815.599 34.8223V477.598L780.606 512.59H325.734L290.384 477.239H0V34.6523L34.6523 0H780.776L815.599 34.8223Z" />
                                        </clipPath>
                                    </defs>
                                    <image href="/img/index/s1.webp" x="0" y="0" width="816"
                                        height="513" preserveAspectRatio="xMidYMid slice" clip-path="url(#cut1)" />
                                </svg>
                            </SwiperSlide>
                            <SwiperSlide>
                                <svg width="100%" height="100%" viewBox="0 0 816 513"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <defs>
                                        <clipPath id="cut2" clipPathUnits="userSpaceOnUse">
                                            <path
                                                d="M815.599 34.8223V477.598L780.606 512.59H325.734L290.384 477.239H0V34.6523L34.6523 0H780.776L815.599 34.8223Z" />
                                        </clipPath>
                                    </defs>
                                    <image href="/img/index/s2.webp" x="0" y="0" width="816"
                                        height="513" preserveAspectRatio="xMidYMid slice" clip-path="url(#cut2)" />
                                </svg>
                            </SwiperSlide>
                            <SwiperSlide>
                                <svg width="100%" height="100%" viewBox="0 0 816 513"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <defs>
                                        <clipPath id="cut3" clipPathUnits="userSpaceOnUse">
                                            <path
                                                d="M815.599 34.8223V477.598L780.606 512.59H325.734L290.384 477.239H0V34.6523L34.6523 0H780.776L815.599 34.8223Z" />
                                        </clipPath>
                                    </defs>
                                    <image href="/img/index/s3.webp" x="0" y="0" width="816"
                                        height="513" preserveAspectRatio="xMidYMid slice" clip-path="url(#cut3)" />
                                </svg>
                            </SwiperSlide>
                            <SwiperSlide>
                                <svg width="100%" height="100%" viewBox="0 0 816 513"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <defs>
                                        <clipPath id="cut3" clipPathUnits="userSpaceOnUse">
                                            <path
                                                d="M815.599 34.8223V477.598L780.606 512.59H325.734L290.384 477.239H0V34.6523L34.6523 0H780.776L815.599 34.8223Z" />
                                        </clipPath>
                                    </defs>
                                    <image href="/img/index/s4.webp" x="0" y="0" width="816"
                                        height="513" preserveAspectRatio="xMidYMid slice" clip-path="url(#cut3)" />
                                </svg>
                            </SwiperSlide>
                            <SwiperSlide>
                                <svg width="100%" height="100%" viewBox="0 0 816 513"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <defs>
                                        <clipPath id="cut3" clipPathUnits="userSpaceOnUse">
                                            <path
                                                d="M815.599 34.8223V477.598L780.606 512.59H325.734L290.384 477.239H0V34.6523L34.6523 0H780.776L815.599 34.8223Z" />
                                        </clipPath>
                                    </defs>
                                    <image href="/img/index/s5.webp" x="0" y="0" width="816"
                                        height="513" preserveAspectRatio="xMidYMid slice" clip-path="url(#cut3)" />
                                </svg>
                            </SwiperSlide>
                            <SwiperSlide>
                                <svg width="100%" height="100%" viewBox="0 0 816 513"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <defs>
                                        <clipPath id="cut3" clipPathUnits="userSpaceOnUse">
                                            <path
                                                d="M815.599 34.8223V477.598L780.606 512.59H325.734L290.384 477.239H0V34.6523L34.6523 0H780.776L815.599 34.8223Z" />
                                        </clipPath>
                                    </defs>
                                    <image href="/img/index/s6.webp" x="0" y="0" width="816"
                                        height="513" preserveAspectRatio="xMidYMid slice" clip-path="url(#cut3)" />
                                </svg>
                            </SwiperSlide>
                        </Swiper>

                        <div
                            class="dot absolute bottom-[-1%] lg:bottom-[-4%] 3xl:bottom-[-1%] left-[12%] lg:left-[13%]  z-5 w-full flex ">
                            <div v-for="(slide, index) in slides" :key="index"
                                class="w-[5%] flex justify-center mx-[-2px] lg:mx-[-5px]">
                                <NuxtImg
                                    :src="activeSlide === index ? '/img/index/img-dot-d.svg' : '/img/index/img-dot.svg'"
                                    alt="" class="w-full h-full object-cover cursor-pointer"
                                    @click="goToSlide(index)" />
                            </div>
                        </div>

                        <div
                            class="hidden lg:flex lg:absolute bg-green w-[37px] h-[163px] mix-blen-plus-lighter z-4 top-[30%]">

                        </div>
                    </div>
                </div>

                <FedFooter class="relative z-5" />
            </section>

        </section>


    </main>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import { useCustomScrollObserver } from '~/composables/useCustomScrollObserver'
import 'swiper/css'
import 'swiper/css/autoplay'

// 使用自定義滾動觀察器（自動處理 Locomotive Scroll 和清理）
const { createObserver } = useCustomScrollObserver()

// 動畫元素 ref
const pitayaRef = ref<HTMLElement | null>(null)
const arrowsRef = ref<HTMLElement | null>(null)
const titleRef = ref<HTMLElement | null>(null)
const dateRef = ref<HTMLElement | null>(null)
const textLtRef = ref<HTMLElement | null>(null)
const binary1Ref = ref<HTMLElement | null>(null)
const binary2Ref = ref<HTMLElement | null>(null)
const whiteBlockRef = ref<HTMLElement | null>(null)
const bottomArrowRef = ref<HTMLElement | null>(null)

// 輪播數據
const slides = ref([1, 2, 3, 4, 5, 6]) // 6 個輪播項目
const activeSlide = ref(0) // 當前激活的 slide 索引
let swiperInstance: any = null

// Swiper 初始化回調
const onSwiper = (swiper: any) => {
    swiperInstance = swiper
}

// Slide 切換回調
const onSlideChange = (swiper: any) => {
    activeSlide.value = swiper.realIndex
}

// 點擊 dot 跳轉到對應 slide
const goToSlide = (index: number) => {
    if (swiperInstance) {
        swiperInstance.slideToLoop(index)
    }
}

// 設置自定義動畫觀察器
onMounted(() => {
    if (typeof window === 'undefined') return

    // 創建觀察器
    const observer = createObserver()
    if (!observer) return

    // 觀察標題元素（第一個出現）
    if (titleRef.value) {
        observer.observe(titleRef.value)
    }

    // 延遲觀察日期元素（創造層次感）
    if (dateRef.value) {
        setTimeout(() => {
            if (observer && dateRef.value) {
                observer.observe(dateRef.value)
            }
        }, 300)
    }

    // 觀察火龍果元素
    if (pitayaRef.value) {
        observer.observe(pitayaRef.value)
    }

    // 延遲觀察箭頭元素（創造層次感）
    if (arrowsRef.value) {
        setTimeout(() => {
            if (observer && arrowsRef.value) {
                observer.observe(arrowsRef.value)
            }
        }, 200)
    }

    // 觀察裝飾元素
    const decorativeElements = [
        { ref: textLtRef, delay: 0 },
        { ref: binary1Ref, delay: 100 },
        { ref: binary2Ref, delay: 150 },
        { ref: whiteBlockRef, delay: 200 },
        { ref: bottomArrowRef, delay: 250 }
    ]

    decorativeElements.forEach(({ ref: elementRef, delay }) => {
        if (elementRef.value) {
            if (delay > 0) {
                setTimeout(() => {
                    if (observer && elementRef.value) {
                        observer.observe(elementRef.value)
                    }
                }, delay)
            } else {
                observer.observe(elementRef.value)
            }
        }
    })
})
</script>

<style>
/* Locomotive Scroll CSS */
@import 'locomotive-scroll/dist/locomotive-scroll.css';
</style>

<style scoped>
.fade-in-left {
    translate: -100px 0;
    opacity: 0;
}

/* 當元素進入視窗時觸發動畫 */
.fade-in-left.is-inview,
.is-inview .fade-in-left {
    animation: slideInFromLeft 1s ease-out forwards;
}

/* 從左往右滑入的關鍵幀動畫 */
@keyframes slideInFromLeft {
    from {
        translate: -100px 0;
        opacity: 0;
    }

    to {
        translate: 0 0;
        opacity: 1;
    }
}

/* 從右往左滑入動畫 */
.fade-in-right {
    translate: 100px 0;
    opacity: 0;
}

/* 當元素進入視窗時觸發動畫 */
.fade-in-right.is-inview,
.is-inview .fade-in-right {
    animation: slideInFromRight 1s ease-out forwards;
}

/* 從右往左滑入的關鍵幀動畫 */
@keyframes slideInFromRight {
    from {
        translate: 100px 0;
        opacity: 0;
    }

    to {
        translate: 0 0;
        opacity: 1;
    }
}

/* 從下往上滑入動畫 */
.fade-in-up {
    translate: 0 50px;
    opacity: 0;
}

/* 當元素進入視窗時觸發動畫 */
.fade-in-up.is-inview,
.is-inview .fade-in-up {
    animation: slideInFromBottom 1s ease-out forwards;
}

/* 從下往上滑入的關鍵幀動畫 */
@keyframes slideInFromBottom {
    from {
        translate: 0 50px;
        opacity: 0;
    }

    to {
        translate: 0 0;
        opacity: 1;
    }
}

/* 響應式調整 */
@media (max-width: 768px) {
    .fade-in-left {
        translate: -50px 0;
        opacity: 0;
    }

    .fade-in-right {
        translate: 50px 0;
        opacity: 0;
    }

    .fade-in-up {
        translate: 0 30px;
        opacity: 0;
    }

    @keyframes slideInFromLeft {
        from {
            translate: -50px 0;
            opacity: 0;
        }

        to {
            translate: 0 0;
            opacity: 1;
        }
    }

    @keyframes slideInFromRight {
        from {
            translate: 50px 0;
            opacity: 0;
        }

        to {
            translate: 0 0;
            opacity: 1;
        }
    }

    @keyframes slideInFromBottom {
        from {
            translate: 0 30px;
            opacity: 0;
        }

        to {
            translate: 0 0;
            opacity: 1;
        }
    }
}
</style>
